import React from "react";
import {useTranslation} from "react-i18next";
import {PieReportWidget} from "../PieReportWidget/PieReportWidget";

export const OrderCountStatsWidget = ({data, loading}) => {
    const {t} = useTranslation(["orderCountStatsWidget"]);
    const orderCountData = [
        {
            name: t("orderCountData.delivered", {ns: "orderCountStatsWidget"}),
            value: data?.delivered || 0,
            color: "#72ECA5"
        },
        {
            name: t("orderCountData.canceled", {ns: "orderCountStatsWidget"}),
            value: data?.canceled || 0,
            color: "#FA7880"
        }
    ];
    return (
        <PieReportWidget
            data={orderCountData}
            loading={loading}
            title={
                <h3>
                    {t("orderCountTitle", {ns: "orderCountStatsWidget"})}:{" "}
                    <b>{(data?.delivered + data?.canceled).toString() || "0"}</b>
                </h3>
            }
        />
    );
};
